import tastify from '@frontastic/catwalk/src/js/helper/tastify';
import Button from '@srcDS/js/components/atoms/button';
import { Image } from '@srcDS/js/components/atoms/image/Image';

const CtaTastic = (props) => {
  const { data } = props;
  const { buttonIcon, buttonTitle, buttonType, buttonUrl, iconPosition, buttonState } = data;

  return (
    <div style={{ width: 'max-content', margin: 20 }}>
      <Button
        disabled={buttonState === 'inactive'}
        icon={
          buttonIcon?.media ? (
            <Image alt={buttonIcon?.media?.alt} itemProp="image" image={buttonIcon?.media?.file} />
          ) : null
        }
        nodeLink={buttonUrl}
        variant={buttonType}
        iconPosition={iconPosition}
      >
        {buttonTitle}
      </Button>
    </div>
  );
};

export default tastify({
  connect: { context: true },
  translate: true,
})(CtaTastic);
